import { Link } from 'react-router-dom';
import { games, gameCategories } from '@/mocks/games';
import GameCard from '@/components/base/GameCard';

export default function FeaturedGames() {
  const featuredGames = games.filter((g) => g.featured).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门黄油网页游戏推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            精选最受欢迎的热门黄油网页游戏，高评分、高人气，助你快速找到心仪的黄油网页游戏
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-product-shop="">
          {featuredGames.map((game) => {
            const category = gameCategories.find((c) => c.slug === game.category);
            return (
              <GameCard
                key={game.id}
                id={game.id}
                title={game.title}
                slug={game.slug}
                category={game.category}
                categoryName={category?.name || game.category}
                image={game.image}
                rating={game.rating}
                players={game.players}
              />
            );
          })}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/role-playing"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-secondary-100 hover:bg-secondary-200 text-secondary-800 font-medium rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
          >
            查看全部游戏
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}